export default "__VITE_ASSET__YrpZ28SU__"